export default "__VITE_ASSET__BMZA1bN7__"